// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"395":"e70c98d8","527":"30091240","616":"8f27480f"}[chunkId] + ".chunk.js";
};